<template>
    <div class="devices">
      <Submenu
        :routes="{
          'devices.index': {
            title: l.t('app.devices', 'Devices'),
            subroutes: ['devices.show']
          },
          'devices.create': {
            title: l.t('menu.add-generic-device', 'Add generic device')
          },
          'devices.buy': {
            title: l.t('menu.buy-device', 'Buy device')
          },
          'devices.my-orders': {
            title: l.t('menu.my-orders', 'My orders'),
            subroutes: ['devices.my-orders.show']
          },
        }"
        :key="`${l.detect()}${$route.name}`"
      />
      <DevicesFragment
        v-if="$route.name === 'devices.index'"
        data-test-id="devices-list"
      />
      <DevicesCreateFragment
        v-if="$route.name === 'devices.create'"
        data-test-id="devices-create"
      />
      <DevicesShowFragment
        v-if="$route.name === 'devices.show'"
        data-test-id="devices-show"
      />
      <OrdersCreate
        v-if="$route.name === 'devices.buy'"
        data-test-id="devices-buy"
      />
      <OrdersIndex
        v-if="$route.name === 'devices.my-orders'"
        data-test-id="devices-orders"
      />
      <OrdersShow
        v-if="$route.name === 'devices.my-orders.show'"
        data-test-id="devices-orders-show"
      />
    </div>
</template>

<script>
  import l from '../../../libs/lang';
  import {OrdersIndex, OrdersShow, OrdersCreate} from 'orders-components';
  import Submenu from '../../elements/Submenu.vue';
  import DevicesFragment from './index.vue';
  import DevicesShowFragment from './show.vue';
  import DevicesCreateFragment from './create.vue';

  export default {
    components: {
      Submenu,
      OrdersShow,
      OrdersIndex,
      OrdersCreate,
      DevicesFragment,
      DevicesShowFragment,
      DevicesCreateFragment,
    },
    data() {
      return {
        l,
      };
    },
    beforeRouteLeave(to, from, next) {
      if (window.deleting_in_progress) {
        this.$emit('userRedirected', to, from, next);
      } else {
        next();
      }
    },
  };
</script>
